const colors = {
  WHITE: "#ffffff",
  LIGHT: "#F5F5F5",
  MID: "#B9B9B9",
  DARK: "#464646",
  CHERRY: "#EB175E",
  APPLE: "#93B724",
}

export default colors;